export default __webpack_public_path__ + "static/media/step5_img1.6571f6c9.png";